function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 60,
  fill: "#F5F5F5"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 11,
  fill: "#0038B8"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  y: 49,
  width: 90,
  height: 11,
  fill: "#0038B8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M53.1568 29.9654L57.188 22.9832H49.1258L45.0939 16L41.0622 22.9832H33L37.0312 29.9654L33 36.9476H41.0622L45.0939 43.9309L49.1256 36.9476H57.1878L53.1568 29.9654ZM53.2329 25.2668L51.8384 27.682L50.444 25.2668H53.2329ZM50.5201 29.9654L47.8073 34.6641H42.3804L39.6677 29.9654L42.3805 25.2668H47.8074L50.5201 29.9654ZM45.0939 20.5671L46.4889 22.9834H43.6989L45.0939 20.5671ZM36.9549 25.2668H39.7437L38.3492 27.682L36.9549 25.2668ZM36.9549 34.6641L38.3494 32.2488L39.7438 34.6641H36.9549ZM45.0939 39.3637L43.6989 36.9475H46.4889L45.0939 39.3637ZM51.8384 32.2488L53.2329 34.6641H50.4441L51.8384 32.2488Z",
  fill: "#0038B8"
});

var SvgIls = function SvgIls(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIls, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ILS.5273c722.svg";
export { ForwardRef as ReactComponent };